import BaseHeader, { Level } from '@editorjs/header'
import { IconH1, IconH2, IconH3 } from '@codexteam/icons'
import { IconTitle1, IconTitle2, IconSubTitle } from './icons'

const availableLevels = [
    { number: 1 },
    { number: 2 },
    { number: 3 },
    { number: 4 },
    { number: 5 },
    { number: 6 },
]

const levelIcons = {
    1: IconTitle1,
    2: IconTitle2,
    3: IconH1,
    4: IconH2,
    5: IconH3,
    6: IconSubTitle,
}

export class Header extends BaseHeader {
    get levels(): Level[] {
        return [
            {
                number: 1,
                tag: 'H1',
                svg: levelIcons[1],
            },
            {
                number: 2,
                tag: 'H2',
                svg: levelIcons[2],
            },
            {
                number: 3,
                tag: 'H3',
                svg: levelIcons[3],
            },
            {
                number: 4,
                tag: 'H4',
                svg: levelIcons[4],
            },
            {
                number: 5,
                tag: 'H5',
                svg: levelIcons[5],
            },
            {
                number: 6,
                tag: 'H6',
                svg: levelIcons[6],
            },
        ]
    }

    static get toolbox() {
        return availableLevels.map((level) => ({
            icon: levelIcons[level.number],
            title: `Heading${level.number}`,
            data: {
                level: level.number,
            },
        }))
    }
}
